import React, { Component } from 'react';

export default class MainRowSection extends Component {

  render() {
    return (
      <div className='pageHead-mainRow-container' >
        <div className='pageHead-mainRow wrapper'>
          <h1 className='pageHead-title'>Consulta de Envíos de Correo a SUNARP</h1>
          <div className='pageHead-mainRow-actions'>
            <div className='dropdown kebab' role='group'>
              <button className='btn dropdown-toggle kebab-btn ' name={'btnDropdownToggle'} ><i className='ion-android-more-vertical' name={'iconDropdownToggle'} /></button>
              <ul className='dropdown-menu dropdown-menu-right' >
                <li>
                <a className='pageHead-tableActionItem' onClick={this.props.clickDescargarExcel} ><i className='ion-arrow-down-a c-cyan' /><span>Descargar Excel</span></a>
                </li>
              </ul>
            </div>
          </div>
        </div>  
      </div>
      
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Inmatriculacion/MainRowSection.js